/* ========= ASSOCIATE VARIANT CAROUSEL IMAGES FUNCTIONALITY ========= */
document.addEventListener("DOMContentLoaded", () => {
  const galleries = document.querySelectorAll('media-gallery[data-associated-images="true"]');
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    initAssociatedImages(gallery);
  });

  function initAssociatedImages(gallery) {
    const viewer = gallery.querySelector("product-media-slider");
    const thumbnails = gallery.querySelector("product-thumbnail-slider");
    if (!viewer || !thumbnails) return;

    let currentVariantId = "";
    let updateScheduled = false;
    let originalMediaOrder = null;
    let originalThumbOrder = null;
    /* ========= INITIAL LOAD ========= */
    setTimeout(() => { updateGallery(); }, 50);

    /* ========= WATCH VARIANT CHANGES ========= */
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      currentVariantId = variantInput.value.toLowerCase();

      const observer = new MutationObserver(() => {
        const newVariantId = variantInput.value.toLowerCase();
        if (newVariantId !== currentVariantId) {
          currentVariantId = newVariantId;
          gallery.style.visibility = "hidden";
          scheduleUpdate();
        }
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ["value"],
      });

      variantInput.addEventListener("change", () => {
        gallery.style.visibility = "hidden";
        scheduleUpdate();
      });
    }

    /* ========= DEBOUNCED UPDATE ========= */
    function scheduleUpdate() {
      if (updateScheduled) return;
      updateScheduled = true;
      setTimeout(() => {
        updateScheduled = false;
        updateGallery();
      }, 150);
    }

    /* ========= DEDUPLICATE helper ========= */
    function deduplicateByMediaId(items) {
      const seen = new Set();
      return items.filter((item) => {
        const id = item.dataset.mediaId;
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
    }

    /* ========= GET ALT TEXT — works for both images and videos ========= */
    function getMediaAlt(item) {
      // 1. Try <img> alt first
      const img = item.querySelector("img");
      if (img && img.getAttribute("alt")) {
        return img.getAttribute("alt").toLowerCase();
      }

      // 2. Check the item wrapper attributes directly (Shopify puts alt here)
      const itemAlt =
        item.getAttribute("data-alt") ||
        item.getAttribute("data-media-alt") ||
        item.getAttribute("aria-label") ||
        item.getAttribute("title") ||
        "";

      if (itemAlt) return itemAlt.toLowerCase();

      // 3. Try <video>
      const video = item.querySelector("video");
      if (video) {
        const videoAlt =
          video.getAttribute("alt") ||
          video.getAttribute("data-alt") ||
          video.getAttribute("title") ||
          "";
        if (videoAlt) return videoAlt.toLowerCase();
      }

      // 4. Try <iframe> (YouTube/Vimeo)
      const iframe = item.querySelector("iframe");
      if (iframe) {
        const iframeAlt =
          iframe.getAttribute("title") ||
          iframe.getAttribute("data-alt") ||
          "";
        if (iframeAlt) return iframeAlt.toLowerCase();
      }

      // 5. Try Shopify deferred-media
      const deferredMedia = item.querySelector("deferred-media, .deferred-media");
      if (deferredMedia) {
        const deferredAlt =
          deferredMedia.getAttribute("data-alt") ||
          deferredMedia.getAttribute("data-media-alt") ||
          deferredMedia.getAttribute("aria-label") ||
          "";
        if (deferredAlt) return deferredAlt.toLowerCase();
      }

      return "";
    }

    /* ========= CHECK if item has any valid media ========= */
    function hasValidMedia(item) {
      // Check by media type attribute (most reliable for Shopify)
      const mediaType = item.getAttribute("data-media-type") || item.closest("[data-media-type]")?.getAttribute("data-media-type") || "";
      if (mediaType) return true;

      return !!(
        item.querySelector("img") ||
        item.querySelector("video") ||
        item.querySelector("iframe") ||
        item.querySelector("deferred-media") ||
        item.querySelector(".deferred-media") ||
        item.querySelector("video-media") ||
        item.querySelector(".media--video") ||
        item.querySelector("[data-media-type]")
      );
    }

    /* ========= UPDATE GALLERY ========= */
    function updateGallery() {
      const variantInput = document.querySelector('input[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value.toLowerCase();
      const mediaWrapper = viewer.querySelector(".slider-wrapper");
      const thumbWrapper = thumbnails.querySelector(".slider-wrapper");
      if (!mediaWrapper || !thumbWrapper) return;

      /* ========= REMOVE CLONES (viewer) ========= */
      mediaWrapper.querySelectorAll(".slider-slide--clone").forEach((c) => c.remove());

      /* ========= ALL ITEMS ========= */
      if (!originalMediaOrder) {
        originalMediaOrder = Array.from(mediaWrapper.querySelectorAll(".product-media-item"));
        originalThumbOrder = Array.from(thumbWrapper.querySelectorAll(".thumbnail-list-item"));
      }
      const mediaItems = originalMediaOrder;
      const thumbItems = originalThumbOrder;

      /* ========= BUILD THUMB LOOKUP MAP ========= */
      const thumbByMediaId = new Map();
      thumbItems.forEach((item) => {
        const target = item.dataset.target;
        if (target) thumbByMediaId.set(target, item);
        item.style.display = "none";
      });

      /* ========= RESET ========= */
      mediaItems.forEach((item) => {
        item.style.display = "none";
      });

      /* ========= CATEGORISE ========= */
      const seenInCategorisation = new Set();
      const featureMedia = [];
      const globalMedia = [];
      const variantMatchedMedia = [];
      const fallbackMedia = [];
      const productForm = gallery.closest('product-form, form[data-type="add-to-cart-form"]');
      const selectedMetalInput = productForm?.querySelector('input[name="Metal"]:checked')
        || document.querySelector('input[name="Metal"]:checked'); // fallback
      const selectedMetal = (selectedMetalInput?.value || "").toLowerCase();
      const selectedVariantData = JSON.parse(document.querySelector("[data-selected-variant]")?.textContent || "{}");
      const featuredMediaId = String(selectedVariantData?.featured_media?.id || "");

      mediaItems.forEach((item) => {
        if (!hasValidMedia(item)) return;

        const mediaId = String(item.dataset.mediaId || "");
        if (!mediaId || seenInCategorisation.has(mediaId)) return;
        seenInCategorisation.add(mediaId);

        const alt = getMediaAlt(item);

        // Detect if this is a video item
        const isVideo = !!(
          item.querySelector("video") ||
          item.querySelector("iframe") ||
          item.querySelector("deferred-media") ||
          item.querySelector(".deferred-media") ||
          item.querySelector("video-media") ||
          item.getAttribute("data-media-type")?.includes("video")
        );

        const isVariantMatch =
          (selectedMetal && alt.includes(selectedMetal) && rc_product_type !== 'rc_bespoke_ring_builder') ||
          alt.includes(variantId);

        if (featuredMediaId && mediaId === featuredMediaId) {
          featureMedia.push(item);
          if (isVariantMatch) variantMatchedMedia.push(item);
        } else if (alt.includes("global")) {
          globalMedia.push(item);
        } else if (isVideo && !alt) {
          // VIDEO WITH NO ALT: treat as global so it always shows
          globalMedia.push(item);
        } else if (isVariantMatch) {
          variantMatchedMedia.push(item);
        } else {
          fallbackMedia.push(item);
        }
      });

      /* ========= FINAL MEDIA ========= */
      let finalMedia = [];

      if (rc_product_type === 'rc_bespoke_ring_builder') {
        finalMedia = deduplicateByMediaId([
          ...variantMatchedMedia,
          ...globalMedia,
        ]);
      } else {
        const hasVariantSpecificImages = variantMatchedMedia.length > 0;
        if (hasVariantSpecificImages) {
          finalMedia = deduplicateByMediaId([
            ...featureMedia,
            ...globalMedia,
            ...variantMatchedMedia,
          ]);
        } else {
          // No variant-specific match — mirror live theme: feature image first,
          // then everything else in its original order (no global regrouping)
          const nonFeature = mediaItems.filter((item) => !featureMedia.includes(item));
          finalMedia = deduplicateByMediaId([
            ...featureMedia,
            ...nonFeature,
          ]);
        }
      }

      if (!finalMedia.length) {
        finalMedia = deduplicateByMediaId([...mediaItems]);
      }

      /* ========= SHOW + REORDER (viewer + thumbs) ========= */
      const mediaFragment = document.createDocumentFragment();
      const thumbFragment = document.createDocumentFragment();

      finalMedia.forEach((item) => {
        item.style.display = "";
        mediaFragment.appendChild(item);

        const mediaId = item.dataset.mediaId;

        /* ========= Sync thumbnail via map lookup ========= */
        const thumb = thumbByMediaId.get(mediaId);
        if (thumb) {
          thumb.style.display = "";
          thumbFragment.appendChild(thumb);
        }
      });

      /* ========= APPEND viewer + thumbs ========= */
      mediaWrapper.appendChild(mediaFragment);
      thumbWrapper.appendChild(thumbFragment);

      /* ========= Reset active states ========= */
      mediaWrapper.querySelectorAll(".product-media-item").forEach((slide) => {
        slide.classList.remove("is-active", "active", "is-current-variant-media");
      });

      /* ========= REINSTALL SLIDERS (viewer + thumbs) ========= */
      if (viewer.reInstall) viewer.reInstall();
      if (thumbnails.reInstall) thumbnails.reInstall();

      /* ========= NOTIFY MODAL SCRIPT ========= */
      gallery.dispatchEvent(
        new CustomEvent("gallery:updated", {
          bubbles: true,
          detail: { mediaIds: finalMedia.map((i) => i.dataset.mediaId) },
        })
      );

      /* ========= FORCE FIRST IMAGE + REVEAL ========= */
      requestAnimationFrame(() => {
        const firstMedia = finalMedia[0];
        if (!firstMedia) return;
        // Set fetchpriority="high" on the first (hero) image for LCP
        const firstImg = firstMedia.querySelector("img");
        if (firstImg) firstImg.setAttribute("fetchpriority", "high");

        const mediaId = firstMedia.dataset.mediaId;
        thumbWrapper.querySelectorAll("button").forEach((btn) => btn.removeAttribute("aria-current"));

        const firstThumb = thumbByMediaId.get(mediaId);
        const firstThumbButton = firstThumb?.querySelector("button");
        if (firstThumbButton) {
          firstThumbButton.setAttribute("aria-current", "true");
        }

        if (viewer.slider?.goToSlide) {
          viewer.slider.goToSlide(0);
        } else if (viewer.slider?.slideTo) {
          viewer.slider.slideTo(0);
        }

        /* ========= REVEAL GALLERY ========= */
        gallery.style.visibility = "";
      });
    }
  }
});